import jwtDecode from "jwt-decode";

export const isTokenValid = () => {
  const token = localStorage.getItem("token");

  if (!token) {
    return false;
  }

  try {
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    // No `exp` claim, or already expired => invalid. Clear the dead token so
    // the app doesn't keep treating a present-but-invalid token as logged in.
    if (!decodedToken.exp || decodedToken.exp <= currentTime) {
      localStorage.removeItem("token");
      return false;
    }
    return true;
  } catch (error) {
    localStorage.removeItem("token");
    return false;
  }
};

export const checkTokenUser = () => {
  const token = localStorage.getItem("token");
  if (token) {
    try {
      const decodedJwt = jwtDecode(token);
      return (
        decodedJwt.user.role !== "admin" || decodedJwt.user.role === undefined
      );
    } catch (error) {
      return null;
    }
  }
};

export const checkTokenUserAdmin = () => {
  const token = localStorage.getItem("token");
  if (token) {
    try {
      const decodedJwt = jwtDecode(token);
      return {
        isAuthenticated: decodedJwt?.user?.role !== "admin",
        isAuthenticatedAdmin: decodedJwt?.user?.role === "admin"
      }
    } catch (error) {
      return {
        isAuthenticated: false,
        isAuthenticatedAdmin: false
      }
    }
  }

  return {
    isAuthenticated: false,
    isAuthenticatedAdmin: false
  }
}

// True when the logged-in customer has a business (B2B) account. Older tokens
// nest the role under `user.id`, so both places are checked. Any problem
// reading the token means "not business" -- never an error.
export const checkTokenUserBusiness = () => {
  try {
    const token = localStorage.getItem("token");
    if (!token) return false;
    const decodedJwt = jwtDecode(token);
    return (decodedJwt?.user?.role ?? decodedJwt?.user?.id?.role) === "business";
  } catch (error) {
    return false;
  }
};
